module.exports = __webpack_public_path__ + "static/media/info_icon.fd25152f.svg";